import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "store";

import { $apiWithoutClient } from "modules/global";

import { IOlympicList } from "..";

export const useActiveOlympic = () => {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...args } = useQuery<{ activeOlympic: IOlympicList[] }>({
    queryKey: ['active-olympic'],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get('/olympic/olympics-list');

      return { activeOlympic: data?.data };
    },
    enabled: isAuthenticated
  });

  return { ...data, ...args };
};
